import React from 'react';
import {
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  SelectChangeEvent
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { ja } from 'date-fns/locale';
import { subMonths, startOfMonth, endOfMonth } from 'date-fns';
import { DateRange } from '../../types';

interface DateRangeSelectorProps {
  dateRange: DateRange;
  onDateRangeChange: (dateRange: DateRange) => void;
}

type DateRangeType = 'all' | 'month' | 'custom';

const DateRangeSelector: React.FC<DateRangeSelectorProps> = ({
  dateRange,
  onDateRangeChange
}) => {
  const [rangeType, setRangeType] = React.useState<DateRangeType>('all');

  const handleRangeTypeChange = (event: SelectChangeEvent<DateRangeType>) => {
    const newRangeType = event.target.value as DateRangeType;
    setRangeType(newRangeType);

    switch (newRangeType) {
      case 'all':
        onDateRangeChange({ startDate: null, endDate: null });
        break;
      case 'month':
        const now = new Date();
        const monthStart = startOfMonth(now);
        const monthEnd = endOfMonth(now);
        onDateRangeChange({ startDate: monthStart, endDate: monthEnd });
        break;
      case 'custom':
        if (!dateRange.startDate && !dateRange.endDate) {
          const now = new Date();
          onDateRangeChange({ 
            startDate: subMonths(now, 1), 
            endDate: now 
          });
        }
        break;
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ja}>
      <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', flexWrap: 'wrap' }}>
        <FormControl sx={{ minWidth: 120 }}>
          <InputLabel>期間</InputLabel>
          <Select
            value={rangeType}
            label="期間"
            onChange={handleRangeTypeChange}
          >
            <MenuItem value="all">全期間</MenuItem>
            <MenuItem value="month">1ヶ月</MenuItem>
            <MenuItem value="custom">カスタム</MenuItem>
          </Select>
        </FormControl>

        {rangeType === 'custom' && (
          <>
            <DatePicker
              label="開始日"
              value={dateRange.startDate}
              onChange={(newDate) => 
                onDateRangeChange({ ...dateRange, startDate: newDate })
              }
              slotProps={{
                textField: {
                  size: 'small'
                }
              }}
            />
            <DatePicker
              label="終了日"
              value={dateRange.endDate}
              onChange={(newDate) => 
                onDateRangeChange({ ...dateRange, endDate: newDate })
              }
              slotProps={{
                textField: {
                  size: 'small'
                }
              }}
            />
          </>
        )}
      </Box>
    </LocalizationProvider>
  );
};

export default DateRangeSelector;